import { render, staticRenderFns } from "./antiFraudResult.vue?vue&type=template&id=b1575cae&scoped=true"
import script from "./antiFraudResult.vue?vue&type=script&lang=js"
export * from "./antiFraudResult.vue?vue&type=script&lang=js"
import style0 from "./antiFraudResult.vue?vue&type=style&index=0&id=b1575cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1575cae",
  null
  
)

export default component.exports